<template>
  <div class="footer-info">
    <div class="links w1200">
      <a href="javascript:void(0)"></a>
      <a href="javascript:void(0)">
        <router-link to="/">首页</router-link>
      </a>|
      <a href="javascript:void(0)">
        <router-link :to="{
          path: '/shop_apply',

        }">商家入驻</router-link>
      </a>|
      <!-- <a href="javascript:void(0)">
        <router-link :to="{
          path: '/shop_street',

        }">店铺街</router-link>
      </a>| -->
      <a href="javascript:void(0)">
        <router-link :to="{
          path: '/brand',

        }">品牌街</router-link>
      </a>|
      <a href="javascript:void(0)">
        <router-link :to="{
          path: '/seckill/list',

        }">限时秒杀</router-link>
      </a>|
      <a href="javascript:void(0)">
        <router-link :to="{
          path: '/special/list',

        }">今日特价</router-link>
      </a>|
      <a href="javascript:void(0)">
        <router-link :to="{
          path: '/discount/list',

        }">限时优惠</router-link>
      </a>
    </div>
    <div class="container">
      <div class="row">
        <!-- BEGIN COPYRIGHT -->
        <div class="item">
          <a
            href="https://beian.miit.gov.cn"
            style="text-decoration: none;"
          >
            <div class="copyright">
              粤ICP备19142968号
            </div>
          </a>
        </div>
        <div class="item">
          <a
            href="https://beian.miit.gov.cn"
            style="text-decoration: none;"
          >
            <p class="copyright">
              粤ICP备19142968号
            </p>
          </a>
        </div>
        <!-- END COPYRIGHT -->
      </div>
    </div>
  </div>
</template>

<script>
  import '@/assets/styles/common.css'
  export default {
    name: 'FooterInfo'
  }
</script>

<style scoped>
  .footer-info {
    border-top: 2px solid #ededed;
    padding: 20px 0;

  }
  .links{
    margin-bottom: 30px;
  }
  .container{
    color: #fff;
    font-size: 12px;
    padding: 5px 0;
    text-align: center;
  }
  .row{

    border-top: 1px solid #ededed;;
  }
  .item{
    width: 50%;
    display: inline-block;
  }
  .links{
    text-align: center;
  }
</style>
